var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LabelComponent',{attrs:{"definition":_vm.definition,"is-locked":_vm.isLocked}}),_c('v-text-field',{attrs:{"dense":"","filled":"","hide-details":"auto","value":_vm.value},on:{"input":function($event){return _vm.change($event)}}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }